document.querySelectorAll(".state-bg").forEach((item) => {
  item.addEventListener("click", function () {
    var link = this.dataset.linkTarget;
    window.location.href = link;
  });
});

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

if (isSafari()) {
  document.addEventListener("DOMContentLoaded", function () {
    let circles = Array.from(
      document.querySelectorAll(".map-pulse")
    );

    function animate() {
      circles.forEach((circle) => {
        let opacity = parseFloat(
          getComputedStyle(circle).getPropertyValue("fill-opacity").trim()
        );
        let rValue =
          18.1249 + (43.4998 - 18.1249) * ((opacity - 0.01) / (0.31 - 0.01));
        circle.setAttribute("r", rValue);
      });

      requestAnimationFrame(animate);
    }

    animate();
  });
}

// Location filtering
jQuery(document).ready(function ($) {
  var currentAreaFilter = "";
  var currentStateFilter = "";
  // Function to toggle dropdown visibility
  function toggleDropdown(dropdown) {
    $(".custom-dropdown").not(dropdown).find(".dropdown-options").hide();

    var optionsDiv = dropdown.find(".dropdown-options");
    optionsDiv.toggle();
  }

  function updateActiveClass() {
    $("#location_state_filter .option").each(function () {
      if ($(this).data("value") === currentStateFilter) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });

    $("#area_type_filter .option").each(function () {
      if ($(this).data("value") === currentAreaFilter) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });
  }

  // Click event on dropdown label to show/hide options
  $(".custom-dropdown").click(function () {
    var dropdown = $(this);
    toggleDropdown(dropdown);
  });

  // Click event on dropdown options
  $(".custom-dropdown .option").click(function () {
    var option = $(this);
    var dropdown = $(this).closest(".custom-dropdown");
    var options = dropdown.find(".option");
    if (options.length === 1) {
      e.preventDefault();
      return;
    }
    var dropdown = option.closest(".custom-dropdown");
    var value = option.data("value");
    var label = option.text();

    // Update the text part of the dropdown label, preserving the icon
    var dropdownLabel = dropdown.find(".dropdown-label").first();
    dropdownLabel
      .contents()
      .first()
      .replaceWith(label + " ");

    // Remove .active from all options and add it to the clicked option
    dropdown.find(".option").removeClass("active");
    option.addClass("active");

    // Apply filtering logic based on the selected value
    if (dropdown.attr("id") === "location_state_filter") {
      currentStateFilter = value;

      // State filtering logic
      $(".location-grid .location-col").each(function () {
        var anchor = $(this).find("a");
        if (value === "") {
          $(this).show();
        } else if (anchor.data("location-state") !== value) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    } else if (dropdown.attr("id") === "area_type_filter") {
      currentAreaFilter = value;

      // Area type filtering logic
      $(".location-grid .location-col").each(function () {
        var anchor = $(this).find("a");
        var matchesAreaFilter =
          currentAreaFilter === "" ||
          anchor.data("location-arrived") === currentAreaFilter;
        var matchesStateFilter =
          currentStateFilter === "" ||
          anchor.data("location-state") === currentStateFilter;

        if (matchesAreaFilter && matchesStateFilter) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    updateActiveClass();
    toggleDropdown(dropdown);
    showHideLocations();

    setGridMinHeight();
  });

  // Close dropdown if clicked outside
  $(document).click(function (event) {
    // Check if the clicked area is outside the dropdowns and not the load more button
    if (
      !$(event.target).closest(".custom-dropdown").length &&
      !$(event.target).closest(".load-more>button").length
    ) {
      $(".dropdown-options").hide();
      // Instead of removing active class, call updateActiveClass
      updateActiveClass();
    }
  });

  // Set default active options
  function setDefaultActiveOption(dropdown) {
    var activeOption = dropdown.find(".option.active").first();
    var labelText = activeOption.text();
    var dropdownLabel = dropdown.find(".dropdown-label").first();
    dropdownLabel
      .contents()
      .first()
      .replaceWith(labelText + " ");
    var value = activeOption.data("value");

    if (dropdown.attr("id") === "location_state_filter") {
      currentStateFilter = value;
    } else if (dropdown.attr("id") === "area_type_filter") {
      currentAreaFilter = value;
    }
  }

  setDefaultActiveOption($("#location_state_filter"));
  setDefaultActiveOption($("#area_type_filter"));

  // Separate function for Load More functionality
  function loadMoreLocations() {
    var shownCount = 0;

    $(".location-grid .location-col").each(function () {
      var anchor = $(this).find("a");
      var matchesAreaFilter =
        currentAreaFilter === "" ||
        anchor.data("location-arrived") === currentAreaFilter;
      var matchesStateFilter =
        currentStateFilter === "" ||
        anchor.data("location-state") === currentStateFilter;

      if (matchesAreaFilter && matchesStateFilter && !$(this).is(":visible")) {
        if (shownCount < 12) {
          $(this).show();
          shownCount++;
        }
      }
    });

    showHideLoadMore();
  }

  function showHideLoadMore() {
    // Use the :visible selector to count the number of visible .location-col elements
    var visibleCount = $(".location-grid .location-col:visible").length;
    var totalMatchedItems = 0;

    $(".location-grid .location-col").each(function () {
      var anchor = $(this).find("a");
      var matchesAreaFilter =
        currentAreaFilter === "" ||
        anchor.data("location-arrived") === currentAreaFilter;
      var matchesStateFilter =
        currentStateFilter === "" ||
        anchor.data("location-state") === currentStateFilter;
      if (matchesAreaFilter && matchesStateFilter) {
        totalMatchedItems++;
      }
    });
    // Show 'Load More' only if there are more matched items than visible ones
    if (visibleCount < totalMatchedItems) {
      $(".load-more").show();
    } else {
      $(".load-more").hide();
    }
  }

  function setGridMinHeight() {
    if ($(window).width() <= 767) {
      var grid = document.querySelector(".location-grid");
      if (grid !== null) {
        grid.style.minHeight = "auto";
      }
      return;
    }
    if (!$(".wf-map-locations").hasClass("no-map")) {
      return;
    }
    var grid = document.querySelector(".location-grid");
    var rows = grid.querySelectorAll(".location-col");
    var maxHeight = 0;
    var originalDisplayStates = [];

    if (grid !== null) {
      // Temporarily show all rows to calculate the height
      // temp set min height to auto
      grid.style.minHeight = "auto";
      rows.forEach((row, index) => {
        originalDisplayStates[index] = row.style.display;
        row.style.display = "inline-flex";
      });
      // console.log(grid.clientHeight);

      maxHeight = grid.clientHeight;

      // Apply the calculated height as min-height
      grid.style.minHeight = maxHeight + "px";

      // Re-apply filters to hide/show rows as necessary
      rows.forEach((row, index) => {
        row.style.display = originalDisplayStates[index];
      });
    }
  }
  setGridMinHeight();

  // if on small screen size, only show a max of 12 locations. If the .load-more>button is clicked, show more locations
  function showHideLocations() {
    if ($(window).width() >= 768) {
      return;
    }
    var totalMatchedItems = 0;

    $(".location-grid .location-col").each(function () {
      var anchor = $(this).find("a");
      var matchesAreaFilter =
        currentAreaFilter === "" ||
        anchor.data("location-arrived") === currentAreaFilter;
      var matchesStateFilter =
        currentStateFilter === "" ||
        anchor.data("location-state") === currentStateFilter;

      if (matchesAreaFilter && matchesStateFilter) {
        totalMatchedItems++;
        // Show/hide logic remains the same
        if (
          $(window).width() < 768 &&
          $(".location-grid .location-col:visible").length <= 12
        ) {
          $(this).show();
        } else {
          $(this).hide();
        }
      } else {
        $(this).hide();
      }
      if ($(window).width() >= 768) {
        $(".load-more").hide();
        $(this).show();
      }
    });

    showHideLoadMore();
  }

  // Bind Load More button click event
  $(".load-more>button")
    .off("click")
    .click(function () {
      loadMoreLocations();
    });

  // Initial call and setting up resize event
  showHideLocations();
  $(window).resize(function () {
    showHideLocations();
    setGridMinHeight();
  });
});
